import styled from '@emotion/styled'
import { Tab } from '@chakra-ui/react'

export const StyledTab = styled(Tab)`
  font-size: small;
`
